import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed}/>
      <main className={'transition-all duration-300 min-h-screen ' + (collapsed ? 'lg:ml-16' : 'lg:ml-64')}>
        <div className="p-4 lg:p-6 pt-16 lg:pt-6"><Outlet/></div>
      </main>
    </div>
  );
}